import { Text } from 'components/Text'
import { styled } from 'stitches.config'

export const ProductName = styled('div', {
  order: 1,

  '@bp2': {
    order: 0,
  },
})

export const Chip = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '4px',
  backgroundColor: '$primary-100',
  borderRadius: '$3',
  border: 'none',
  marginBottom: '$2',

  '@bp2': {
    marginBottom: 0,
  },
})
